import image from "../assets/img/team/1675786229596.jpeg";
import "./Profile.css";

/**
 * Edit these two to switch the LinkedIn / X buttons on.
 * Leave a value empty and its button is simply not rendered.
 */
const LINKEDIN_URL = "https://www.linkedin.com/in/hukum-gosain-9374b1167/";
const X_URL = "https://x.com/HukumGosain";

const EMAIL = "ghukumgh@gmail.com";
const GITHUB_URL = "https://github.com/44hukum";
const ARTICLES_URL = "https://articles.hukumgosain.com.np/";

const ventures = [
  {
    name: "Higain Labs",
    host: "higainlab.com",
    url: "https://higainlab.com",
    role: "Founder & CEO",
    text:
      "An AI product and engineering studio designing and building the products of tomorrow. We work from Nepal with clients across Australia and the U.S., taking smart, future-ready solutions from the first prototype through to the production infrastructure that keeps them running.",
  },
  {
    name: "FoodVerse AI",
    host: "foodverse.ai",
    url: "https://foodverse.ai",
    role: "Founder & CEO",
    text:
      "Nepal's end-to-end hospitality ecosystem. One platform for reservations, property management, floor and room layouts, staff and shifts, IRD-compliant accounts and billing, guest CRM and analytics — plus a guest marketplace that fills the rooms.",
  },
];

const skills = [
  "Python",
  "Django",
  "Flask",
  "Rust",
  "PostgreSQL",
  "Microservices",
  "Docker",
  "AWS",
  "React",
  "AI / ML",
  "TensorFlow",
  "Blockchain",
];

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m2 7 10 6 10-6" />
  </svg>
);

const GithubIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 .5a12 12 0 0 0-3.79 23.4c.6.1.82-.26.82-.58v-2.2c-3.34.72-4.04-1.6-4.04-1.6-.55-1.4-1.34-1.77-1.34-1.77-1.09-.75.08-.73.08-.73 1.2.08 1.84 1.24 1.84 1.24 1.07 1.84 2.8 1.3 3.49 1 .1-.78.42-1.31.76-1.61-2.67-.3-5.47-1.34-5.47-5.96 0-1.32.47-2.39 1.24-3.23-.13-.3-.54-1.53.11-3.18 0 0 1.01-.32 3.3 1.23a11.4 11.4 0 0 1 6 0c2.29-1.55 3.3-1.23 3.3-1.23.65 1.65.24 2.88.12 3.18.77.84 1.23 1.91 1.23 3.23 0 4.63-2.8 5.65-5.48 5.95.43.37.81 1.1.81 2.22v3.29c0 .32.22.69.83.57A12 12 0 0 0 12 .5Z" />
  </svg>
);

const LinkedinIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM2.5 9.5h5V21h-5V9.5Zm7.5 0h4.8v1.57h.07a5.26 5.26 0 0 1 4.73-2.6c5.06 0 6 3.33 6 7.66V21h-5v-4.87c0-1.16-.02-2.66-1.62-2.66-1.63 0-1.88 1.27-1.88 2.58V21h-5V9.5Z" />
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.65l-5.22-6.82-5.96 6.82H1.68l7.73-8.84L1.25 2.25h6.82l4.71 6.23 5.46-6.23Zm-1.16 17.52h1.83L7.01 4.13H5.04l12.04 15.64Z" />
  </svg>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M7 17 17 7M9 7h8v8" />
  </svg>
);

function Profile() {
  return (
    <div className="hg">
      <div className="container hg-shell py-5 my-md-5">
        <header className="hg-hero">
          <img className="hg-avatar mb-4" src={image} alt="Hukum Gosain" width={96} height={96} />
          <h1 className="hg-name">Hukum Gosain</h1>
          <p className="hg-role">
            Founder &amp; CEO <span className="hg-accent">·</span> Higain Labs &amp; FoodVerse AI
          </p>
          <p className="hg-tagline">The Constant Dreamer</p>

          <p className="hg-intro">
            I build software companies out of Kathmandu. Today I run Higain Labs, an AI product and
            engineering studio, and FoodVerse AI, the hospitality platform we are taking to hotels and
            restaurants across Nepal. Before founding them I spent years as a backend engineer shipping
            scalable systems in blockchain, facility management and food delivery — and that is still the
            part of the work I enjoy most.
          </p>

          <nav className="hg-links" aria-label="Profile links">
            <a className="hg-link hg-link--primary" href={ARTICLES_URL} target="_blank" rel="noreferrer">
              <ArrowIcon /> Articles
            </a>
            <a className="hg-link" href={`mailto:${EMAIL}`}>
              <MailIcon /> Email
            </a>
            <a className="hg-link" href={GITHUB_URL} target="_blank" rel="noreferrer">
              <GithubIcon /> GitHub
            </a>
            {LINKEDIN_URL && (
              <a className="hg-link" href={LINKEDIN_URL} target="_blank" rel="noreferrer">
                <LinkedinIcon /> LinkedIn
              </a>
            )}
            {X_URL && (
              <a className="hg-link" href={X_URL} target="_blank" rel="noreferrer">
                <XIcon /> X
              </a>
            )}
          </nav>
        </header>

        <section className="hg-section">
          <h2 className="hg-section-title">Building</h2>
          <div className="row g-3 g-md-4">
            {ventures.map((v) => {
              const Card = v.url ? "a" : "div";
              const linkProps = v.url
                ? { href: v.url, target: "_blank", rel: "noreferrer" }
                : {};
              return (
                <div className="col-12 col-md-6" key={v.name}>
                  <Card className="hg-card" {...linkProps}>
                    <div className="hg-card-head">
                      <h3 className="hg-card-name">{v.name}</h3>
                      {v.host && <span className="hg-card-host">{v.host} ↗</span>}
                    </div>
                    <span className="hg-card-role">{v.role}</span>
                    <p className="hg-card-text">{v.text}</p>
                  </Card>
                </div>
              );
            })}
          </div>
        </section>

        <section className="hg-section">
          <h2 className="hg-section-title">Writing</h2>
          <a className="hg-card" href={ARTICLES_URL} target="_blank" rel="noreferrer">
            <div className="hg-card-head">
              <h3 className="hg-card-name">How things works?</h3>
              <span className="hg-card-host">articles.hukumgosain.com.np ↗</span>
            </div>
            <p className="hg-card-text">
              A beautiful journey of my mind with my imagination — notes on engineering, building
              companies, and whatever else I am trying to understand at the time.
            </p>
          </a>
        </section>

        <section className="hg-section">
          <h2 className="hg-section-title">Background</h2>
          <div className="hg-card">
            <p className="hg-card-text mt-0">
              Python developer by trade, with a track record of designing and shipping highly scalable,
              robust web applications in Flask and Django. I have delivered complex systems across
              blockchain, facility management and food delivery, and work comfortably across microservices
              architecture, Docker, PostgreSQL, AWS and Rust. AI and ML is where the curiosity goes — and,
              now, where the companies go too.
            </p>
            <div className="hg-chips">
              {skills.map((s) => (
                <span className="hg-chip" key={s}>
                  {s}
                </span>
              ))}
            </div>
          </div>
        </section>

        <footer className="hg-footer">
          <p className="mb-0">Kathmandu, Nepal · it's not about what you know, it's about what you can do</p>
        </footer>
      </div>
    </div>
  );
}

export default Profile;
